(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["checkout-button"] && !Shopify.designMode) return;
  try {
    class CheckoutButtonComponent extends HTMLElement {
    connectedCallback() {
      this.variants = this.#readJson('[data-variants]', []);
      this.labels = this.#readJson('[data-labels]', {});
      this.variantInput = this.querySelector('[data-variant-input]');
      this.mainButton = this.querySelector('[data-main-button]');
      this.mainLabel = this.querySelector('[data-main-label]');
      this.mainPrice = this.querySelector('[data-main-price]');
      this.form = this.querySelector('form');
      this.sticky = this.querySelector('[data-sticky]');

      this.handlePickerChange = (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement) || !target.dataset.variantId) return;
        const picker = target.closest('variant-picker');
        if (!picker || picker.dataset.productId !== this.dataset.productId) return;
        this.setVariant(target.dataset.variantId);
      };
      document.addEventListener('change', this.handlePickerChange);

      this.form?.addEventListener('submit', () => {
        this.mainButton?.setAttribute('aria-busy', 'true');
        this.stickyButton?.setAttribute('aria-busy', 'true');
      });

      if (this.sticky) {
        this.stickySelect = this.sticky.querySelector('[data-sticky-select]');
        this.stickyPrice = this.sticky.querySelector('[data-sticky-price]');
        this.stickyCompare = this.sticky.querySelector('[data-sticky-compare]');
        this.stickyButton = this.sticky.querySelector('[data-sticky-button]');
        document.body.appendChild(this.sticky);

        this.stickySelect?.addEventListener('change', () => this.selectFromSticky(this.stickySelect.value));

        if (this.mainButton && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.toggleSticky(scrolledPast);
          });
          this.observer.observe(this.mainButton);
        }
      }

      window.addEventListener('pageshow', () => {
        this.mainButton?.removeAttribute('aria-busy');
        this.stickyButton?.removeAttribute('aria-busy');
      });
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.handlePickerChange);
      this.observer?.disconnect();
      this.sticky?.remove();
    }

    #readJson(selector, fallback) {
      try {
        return JSON.parse(this.querySelector(selector)?.textContent || '');
      } catch {
        return fallback;
      }
    }

    selectFromSticky(variantId) {
      const input = document.querySelector(
        `variant-picker[data-product-id="${this.dataset.productId}"] input[data-variant-id="${variantId}"]`
      );
      if (input instanceof HTMLInputElement && !input.checked) {
        input.click();
      } else {
        this.setVariant(variantId);
      }
    }

    setVariant(variantId) {
      const variant = this.variants.find((item) => String(item.id) === String(variantId));
      if (!variant) return;

      if (this.variantInput) this.variantInput.value = String(variant.id);
      if (this.mainPrice) this.mainPrice.textContent = variant.price;
      if (this.mainLabel) this.mainLabel.textContent = variant.available ? this.labels.label : this.labels.soldOut;
      this.mainButton?.toggleAttribute('disabled', !variant.available);

      if (this.stickySelect) this.stickySelect.value = String(variant.id);
      if (this.stickyPrice) this.stickyPrice.textContent = variant.price;
      if (this.stickyCompare) {
        this.stickyCompare.hidden = !variant.compare;
        this.stickyCompare.textContent = variant.compare || '';
      }
      this.stickyButton?.toggleAttribute('disabled', !variant.available);
    }

    toggleSticky(show) {
      if (!this.sticky) return;
      this.sticky.classList.toggle('is-visible', show);
      this.sticky.toggleAttribute('inert', !show);
    }
  }

  if (!customElements.get('checkout-button-component')) {
    customElements.define('checkout-button-component', CheckoutButtonComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["stock-countdown"] && !Shopify.designMode) return;
  try {
    class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.mode;
      this.offsetMs = Number(this.dataset.offset || 0) * 60000;
      this.end = Number(this.dataset.end) * 1000;
      this.output = this.querySelector('[data-countdown-output]');
      if (!this.output) return;
      if (this.mode !== 'midnight' && !this.end) return;
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    secondsUntilMidnight() {
      const storeTime = new Date(Date.now() + this.offsetMs);
      const elapsed = storeTime.getUTCHours() * 3600 + storeTime.getUTCMinutes() * 60 + storeTime.getUTCSeconds();
      return 86400 - elapsed;
    }

    tick() {
      const left =
        this.mode === 'midnight'
          ? this.secondsUntilMidnight()
          : Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      if (left === 0 && this.mode !== 'midnight') {
        clearInterval(this.interval);
        if (!window.Shopify?.designMode) this.hidden = true;
      }
      const pad = (value) => String(value).padStart(2, '0');
      const hours = Math.floor(left / 3600);
      const minutes = Math.floor((left % 3600) / 60);
      const seconds = left % 60;
      this.output.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }
  }

  if (!customElements.get('countdown-timer')) customElements.define('countdown-timer', CountdownTimer);
  } catch(e) { console.error(e); }
})();

})();
